package com.milta.feature.imports.data.remote

import com.milta.core.network.ApiException
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.imports.data.remote.dto.ImportPdfResultDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.submitFormWithBinaryData
import io.ktor.client.statement.HttpResponse
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess

class ImportPdfApi(private val client: HttpClient) {

    /**
     * POST /api/v1/imports/pdf — single synchronous multipart upload, one required field `File`
     * (MIL-26). Claude Haiku reads the PDF's native text directly, or performs visual OCR itself
     * on a scanned PDF — no separate OCR library call. No session, no attempt tracking: either it
     * returns every detected delivery row or one of the errors mapped by [decodeOrThrow].
     */
    suspend fun extractDeliveriesFromPdf(fileBytes: ByteArray, fileName: String): ImportPdfResultDto =
        client.submitFormWithBinaryData(
            url = "$baseUrl/${Endpoints.importsPdf}",
            formData = formData {
                append(
                    key = "File",
                    value = fileBytes,
                    headers = Headers.build {
                        append(HttpHeaders.ContentDisposition, "filename=\"$fileName\"")
                    },
                )
            },
        ).decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            val message = apiError?.code ?: "error_${status.value}"
            throw ApiException(status.value, message)
        }
        return body()
    }
}
